import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import PersonTypeService from "../../src/Services/PersonType.service";
const PersonTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<PagedResult<PersonType[]>>' is not assignable to type '(ids: string[]) => Promise<PersonType[]>'.
        fetchItemsById: (ids) => {
            return PersonTypeService.search({ ids });
        },
        // @ts-expect-error - TS2322 - Type '(search: string) => Promise<PagedResult<PersonType[]>>' is not assignable to type '(search: string) => Promise<PersonType[]>'.
        fetchOptions: (search) => {
            return PersonTypeService.search({ query: search });
        },
        optionRenderer: function optionRenderer(personType) {
            return _jsx("span", { children: personType.name });
        },
    });
};
export default PersonTypeLookup;
